import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import AppLayout from '../layouts/AppLayout.vue'
import Login from '../pages/auth/Login.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'dashboard' },
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    redirect: { name: 'dashboard' },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('../pages/admin/dashboard/Dashboard.vue'),
      },
      {
        name: 'stake',
        path: 'stake',
        component: () => import('../pages/stakes/StakeView.vue'),
      },
      {
        name: 'history',
        path: 'history',
        component: () => import('../pages/history/HistoryView.vue'),
      },
      {
        name: 'network',
        path: 'network',
        component: () => import('../pages/network/NetworkView.vue'),
      },
      {
        name: 'operations',
        path: 'operations',
        component: () => import('../pages/operations/OperationsView.vue'),
      },
      {
        name: 'copytrade',
        path: 'copytrade',
        component: () => import('../pages/copytrade/CopytradeView.vue'),
      },
      {
        name: 'primezord',
        path: 'primezord',
        component: () => import('../pages/primezord/PrimezordView.vue'),
      },
      {
        name: 'primevault',
        path: 'primevault',
        component: () => import('../pages/prime-vault/PrimeVault.vue'),
      },
      {
        name: 'profile',
        path: 'profile',
        component: () => import('../pages/profile/ProfileView.vue'),
      },
    ],
  },
  {
    path: '/auth/login',
    component: Login,
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = !!localStorage.getItem('token')
  console.log(localStorage.getItem('token'))
  const isLoginRoute = to.path.startsWith('/auth')

  if (!isLoggedIn && !isLoginRoute) {
    return next('/auth/login')
  }

  if (isLoggedIn && isLoginRoute) {
    return next({ name: 'dashboard' })
  }

  return next()
})

export default router
